import React, { useState } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import 'semantic-ui-css/semantic.min.css';
import './Hero2.css';
import Footer from './components/Footer';
import PaginaPrincipal from './components/paginaPrincipal';
import { AuthProvider } from './context/auth';
import AuthRoute from './util/AuthRoute';
import Productos from './components/productos';
import Servicios from './components/servicios';
import Header from './components/Header';
import Clientes from './components/clientes';

function App() {


  const pathname = window.location.pathname;

  console.log(pathname)

  return (
    <AuthProvider>

      <Router>

        <Route exact path="/" component={PaginaPrincipal} />

        {pathname === '/productos' ?
          <div>
            <Productos />
          </div>
          :
          pathname === '/quienessomos' ?
            <div>
              <Servicios />
            </div>
            :
            pathname === '/clientes' ?
              <div>
                <Clientes/>
              </div>
              :''}
            <a href="#contenedorTotal"  className='btn-flotante text-center'><i class="angle double up icon"></i></a>

        <Footer />
      </Router>
    </AuthProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js